import { Component, forwardRef, OnInit } from '@angular/core'
import { FormControlValueAccessor } from '@mistergreen/shared/angular-directives/abstract-value-accessor'
import { NG_ASYNC_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms'
import { BanksAvailableForIdealQuery, BanksAvailableForIdealGQL } from '../../../../../../generated/graphql'
import { pluck } from 'rxjs/operators'
import { ApolloQueryResult } from '@apollo/client/core'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Observable } from 'rxjs'

@UntilDestroy()
@Component({
    selector: 'mg-checkout-payment-method',
    templateUrl: './checkout-payment-method.component.html',
    styleUrls: ['./checkout-payment-method.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckoutPaymentMethodComponent),
            multi: true,
        },
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => CheckoutPaymentMethodComponent),
            multi: true,
        },
    ],
})
export class CheckoutPaymentMethodComponent extends FormControlValueAccessor implements OnInit {
    banks$: Observable<BanksAvailableForIdealQuery['BanksAvailableForIdeal'][]>

    constructor(private banksAvailableForIdealGQL: BanksAvailableForIdealGQL) {
        super()
    }

    ngOnInit() {
        this.banks$ = this.banksAvailableForIdealGQL
            .fetch()
            .pipe(
                untilDestroyed(this),
                pluck<
                    ApolloQueryResult<BanksAvailableForIdealQuery>,
                    BanksAvailableForIdealQuery['BanksAvailableForIdeal'][]
                >('data', 'BanksAvailableForIdeal')
            )
    }

    async validate(): Promise<ValidationErrors | null> {
        return this.value && this.value.toString().trim() !== '' ? null : { value: 'no value set' }
    }
}
